import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { EnergyService } from '../energy.service';
import { DatePipe } from '@angular/common';
import { SharedUtils } from '../../../shared/shared.utils';
import { GeneralService } from '../../../shared/services/general.service';

@Component({
  selector: 'app-energy-gas',
  templateUrl: './energy-gas.component.html',
  styleUrls: ['./energy-gas.component.scss']
})
export class EnergyGasComponent implements OnInit, OnChanges {
  @Input() gasMeterId: String;
  @Input() viewMode: String;
  today: Date = new Date(Date.now());
  auxMode = 1;
  todayValue = 0;
  monthValue = 0;
  loaded = false;
  SharedUtils = SharedUtils;
  constructor(private energyService: EnergyService,
              private datePipe: DatePipe,
              private generalService: GeneralService) { }

  ngOnChanges() {
    this.refreshValues();
  }

  ngOnInit() {
    this.refreshValues();
  }

  checkMode() {
    if (this.viewMode === 'Eur') {
      this.auxMode = 2;
    } else {
      this.auxMode = 1;
    }
  }

  refreshValues() {
    this.loaded = false;
    this.checkMode();
    const dateFormat: string = (this.datePipe.transform(this.today, 'MM-dd-yyyy'));
    this.energyService.getGasTotalByDay(this.gasMeterId, dateFormat, this.auxMode, 2).subscribe(totalDay => {
      if (totalDay[0]) {
        this.todayValue = totalDay[0].Value;
      }
      this.energyService.getGasTotalByMonth(this.gasMeterId, this.today.getMonth() + 1, this.today.getFullYear(),
       this.auxMode).subscribe(totalMonth => {
        if (totalMonth.length > 0) {
          this.monthValue = totalMonth[0].Value;
          this.loaded = true;
        } else {
          this.monthValue = 0;
          this.loaded = true;
        }});
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/energy/energy-gas/energy-gas.component.ts